<div class="tcpv-wrapper">

  <!-- Header -->
  <div class="tcpv-header" *ngIf="title">
    <span class="tcpv-title">{{ title }} ({{ totalCount }})</span>
  </div>

  <!-- Table -->
  <div class="tcpv-body">
    <ng-container *ngIf="tableRows.length > 0; else noDataTpl">
      <app-zorro-table
        [columns]="tableColumns"
        [data]="tableRows"
        [options]="tableOptions">
      </app-zorro-table>
    </ng-container>
    <ng-template #noDataTpl>
      <app-no-data></app-no-data>
    </ng-template>
  </div>

</div>
